export function roundToDecimals(value: number, decimals: number) {
  const powerOfTen = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * powerOfTen) / powerOfTen
}
